import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CalculatorPage() {
  const navigate = useNavigate();
  
  const [missedCalls, setMissedCalls] = useState(4);
  const [closeRate, setCloseRate] = useState(30);
  const [ticketValue, setTicketValue] = useState(250);

  const calculateLoss = () => {
    const monthlyLoss = missedCalls * 4.3 * (closeRate / 100) * ticketValue;
    return Math.round(monthlyLoss).toLocaleString();
  };

  return (
    <div className="min-h-screen bg-[#030712] text-white font-sans flex flex-col relative select-none">
      
      {/* BACK NAVIGATION ARROW */}
      <div className="p-6 absolute top-0 left-0 z-50">
        <button 
          onClick={() => navigate(-1)} 
          className="flex items-center gap-2 text-xs font-semibold text-gray-400 hover:text-white transition-colors group"
        >
          <span className="text-sm transform group-hover:-translate-x-0.5 transition-transform">←</span> Back
        </button>
      </div>

      <main className="flex-grow flex flex-col items-center justify-center p-6 py-24 max-w-7xl mx-auto w-full">
        
        {/* HEADER TEXT */}
        <div className="text-center space-y-3 mb-12 max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-black tracking-tight text-white">
            Missed Call Calculator
          </h1>
          <p className="text-gray-400 text-xs md:text-sm leading-relaxed">
            Stop losing thousands to unpicked-up phones. Atlas AI ensures every plumbing and electrical lead is qualified 24/7/365.
          </p>
        </div>

        {/* METRICS WORKSPACE SLIDERS */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full max-w-5xl items-stretch">
          
          <div className="bg-[#0b1220]/60 border border-gray-900/60 rounded-3xl p-8 flex flex-col justify-between space-y-8 backdrop-blur-sm">
            
            <div className="space-y-3">
              <div className="flex justify-between items-center text-xs font-bold tracking-wide text-gray-400 uppercase">
                <span>Missed Calls Per Week:</span>
                <span className="text-blue-400 font-mono text-sm">{missedCalls}</span>
              </div>
              <input 
                type="range" 
                min="1" 
                max="50" 
                value={missedCalls} 
                onChange={(e) => setMissedCalls(Number(e.target.value))}
                className="w-full h-1.5 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-blue-500"
              />
            </div>

            <div className="space-y-3">
              <div className="flex justify-between items-center text-xs font-bold tracking-wide text-gray-400 uppercase">
                <span>Typical Close Rate:</span>
                <span className="text-blue-400 font-mono text-sm">{closeRate}%</span>
              </div>
              <input 
                type="range" 
                min="5" 
                max="100" 
                step="5"
                value={closeRate} 
                onChange={(e) => setCloseRate(Number(e.target.value))}
                className="w-full h-1.5 bg-gray-800 rounded-lg appearance-none cursor-pointer accent-blue-500"
              />
            </div>

            <div className="space-y-3">
              <label className="block text-xs font-bold tracking-wide text-gray-400 uppercase">
                Average Ticket Value ($):
              </label>
              <input 
                type="number" 
                value={ticketValue} 
                onChange={(e) => setTicketValue(Math.max(0, Number(e.target.value)))}
                className="w-full bg-[#040812] border border-gray-900 rounded-xl px-4 py-3.5 text-sm font-semibold text-white focus:outline-none focus:border-blue-500/50 transition-colors font-mono"
              />
            </div>

          </div>

          {/* CALCULATED OUTPUT METRICS PANEL */}
          <div className="bg-[#0b1220]/60 border border-gray-900/60 rounded-3xl p-8 flex flex-col justify-between items-center text-center backdrop-blur-sm relative min-h-[320px]">
            
            <div className="space-y-2 my-auto">
              <span className="text-[10px] font-black tracking-widest text-gray-500 uppercase block">
                Estimated Monthly Revenue Loss
              </span>
              <div className="text-6xl md:text-7xl font-black tracking-tight text-blue-500 font-mono">
                ${calculateLoss()}
              </div>
            </div>

            <div className="w-full space-y-4">
              <p className="text-[10px] italic text-gray-600">
                *Based on a standard 4.3 week month. Actual results may vary by lead quality.
              </p>
              
              {/* TRIGGER CONVERSION LINK WITH OPTION B FLAGS */}
              <button 
                onClick={() => navigate('/contact?trigger=popup')}
                className="w-full py-4 px-6 bg-blue-600 hover:bg-blue-500 active:scale-[0.99] text-white font-bold rounded-2xl shadow-lg shadow-blue-600/10 transition-all tracking-wide text-sm"
              >
                Stop The Bleeding with Atlas AI
              </button>
            </div>

          </div>

        </div>

      </main>
    </div>
  );
}